import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


const apiUrl = process.env.REACT_APP_API_URL;

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ userData, profile_id }, { rejectWithValue }) => {
    // Validate required parameters
    if (!profile_id) {
      return rejectWithValue('Profile ID is required');
    }

    try {
      const response = await axios.patch(
        `${apiUrl}/Profile/${profile_id}/Update/`,
        userData, // Send userData directly
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Update Error:', error.response || error);
      return rejectWithValue(
        error.response?.data?.message || 
        error.message || 
        'Something went wrong'
      );
    }
  }
);



const userSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    loading: false,
    error: null, // To hold error messages
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null; // Clear previous errors on new request
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.users.findIndex((user) => user.id === action.payload.id);
        if (index !== -1) {
          state.users[index] = action.payload; // Update user in the state
        } else {
          state.users.push(action.payload); // Add new user if not found
        }
        state.error = null; // Clear error if fulfilled
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});



export default userSlice.reducer;
